import { Component, computed, input } from '@angular/core';
import { Icon } from '../../icons';
import { MediaService } from '@frontend/common';
import { TranslocoDirective } from '@jsverse/transloco';

interface IconMinimal {
    identifier_1: string;
    identifier_2?: string;
    name?: string;
}
@Component({
  selector: 'multisite-icon-pill',
  templateUrl: './icon-pill.component.html',
  styleUrls: ['./icon-pill.component.scss'],
  standalone: true,

  imports: [
    TranslocoDirective,
  ]
})
export class IconPillComponent {

  labelTranslationKey =input<string | undefined>(undefined); // 'quiz.test_your_knowledge'
  labelTranslationScope =input<string | undefined>(undefined); // 'quiz.test_your_knowledge'
  labelText =input<string | undefined>(undefined); // 'Test your knowledge'
  fallbackIconClasses =input<string>(''); // 'fa-solid fa-clock'
  imageTransformations = input<string>('w_32,c_fill,ar_1:1,r_max/');
  icon =input<IconMinimal|undefined>(undefined);
  iconClasses = computed<string>(() => {
    const icon = this.icon();
    if (icon) {
      return icon.identifier_1 ?? null;
    } else {
      return this.fallbackIconClasses();
    }
  });
  imgUrl = computed<string | null>(() => {
    const icon = this.icon();
    return icon?.identifier_2 ? this.mediaService.getIconUrlFromIconIdentifier2(icon.identifier_2,this.imageTransformations()):null;
  });
  selectable =input<boolean>(false); // sets 'selectable' class
  active =input<boolean>(false); // sets 'active' class
  disabled =input<boolean>(false); // sets 'disabled' class
  removable =input<boolean>(false); // sets 'removable' class and shows dismiss icon
  compact =input<boolean>(false);
  shape =input<string>('square'); // 'square' or 'round' sets the class icon-pill-square or icon-pill-round
  inverted =input<boolean>(false); // sets 'inverted' class

  constructor(private mediaService : MediaService) { }

  getUrl(icon: IconMinimal) : string {

    return this.mediaService.getIconUrlFromIconIdentifier2(icon.identifier_2,this.imageTransformations());

   }

}
